import { render, staticRenderFns } from "./ChangeLenovoCode.vue?vue&type=template&id=9dce0bb4&scoped=true&"
import script from "./ChangeLenovoCode.vue?vue&type=script&lang=js&"
export * from "./ChangeLenovoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dce0bb4",
  null
  
)

export default component.exports